/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamTypesQueryResponse,
  GetApiV1ExamTypes401,
  GetApiV1ExamTypes500,
} from "../../types/examEvaluationController/GetApiV1ExamExamTypes.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamTypes } from "../../clients/examEvaluationController/getApiV1ExamExamTypes.ts";

export const getApiV1ExamExamTypesQueryKey = () =>
  [{ url: "/api/v1/exam/exam-types" }] as const;

export type GetApiV1ExamExamTypesQueryKey = ReturnType<
  typeof getApiV1ExamExamTypesQueryKey
>;

export function getApiV1ExamExamTypesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamTypesQueryKey();
  return queryOptions<
    GetApiV1ExamTypesQueryResponse,
    ResponseErrorConfig<GetApiV1ExamTypes401 | GetApiV1ExamTypes500>,
    GetApiV1ExamTypesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamTypes({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os tipos de prova disponíveis para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Listar tipos de prova para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-types}
 */
export function useGetApiV1ExamExamTypes<
  TData = GetApiV1ExamTypesQueryResponse,
  TQueryData = GetApiV1ExamTypesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamTypesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamTypesQueryResponse,
        ResponseErrorConfig<GetApiV1ExamTypes401 | GetApiV1ExamTypes500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1ExamExamTypesQueryKey();

  const query = useQuery(
    {
      ...getApiV1ExamExamTypesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1ExamTypes401 | GetApiV1ExamTypes500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
